var $6747fa83b2ba651b$exports = {};
$6747fa83b2ba651b$exports = {
    "pending": `\u{10D}akaj\xface`
};


export {$6747fa83b2ba651b$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
